import { Accordion, AccordionItem, AccordionButton, AccordionIcon, Box, AccordionPanel, useBreakpointValue as breakptValue } from '@chakra-ui/react'

const Document = ({ label, index, link }) => {
    const scrollTop = () => {
        window.scrollTo({
            top: 120 + (56 * index),
            behavior: 'smooth'
        });
    }
    return (
        <AccordionItem onClick={scrollTop}>
            <AccordionButton _expanded={{ bg: '#3182ce6e' }} py={4}>
                <Box flex='1' textAlign='left'>
                    📋 {label}
                </Box>
                <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4}>
                <object data={link} type="application/pdf" width="100%" height="400px">
                    <iframe src={`https://docs.google.com/viewer?url=${link}&embedded=true`}
                            title={label} />
                </object>
            </AccordionPanel>
        </AccordionItem>
    )
}

const listDocument = [
    {
        label: "ระเบียบสำนักงานศาลยุติธรรม ว่าด้วยการเข้าพักอาศัยในอาคารที่พักข้าราชการศาลยุติธรรมในเขตกรุงเทพมหานคร พ.ศ. 2552",
        short: "ระเบียบการเข้าพักอาศัย พ.ศ.2552",
        link: "/doc2/am_1.pdf"
    },
    {
        label: "ระเบียบสำนักงานศาลยุติธรรม ว่าด้วยการเข้าพักอาศัยในอาคารที่พักข้าราชการศาลยุติธรรมในเขตกรุงเทพมหานคร (ฉบับที่ 2) พ.ศ. 2556",
        short: "ระเบียบการเข้าพักอาศัย (ฉบับที่ 2) พ.ศ.2556",
        link: "/doc2/am_2.pdf"
    },
    {
        label: "ประกาศคณะทำงานบริหารอาคารที่พักข้าราชการศาลยุติธรรมในเขตกรุงเทพมหานคร เรื่อง หลักเกณฑ์การจัดลำดับการเข้าพักอาศัย ลงวันที่ 27 ธันวาคม 2561",
        short: "ประกาศเรื่องการจัดลำดับเข้าพักอาศัย",
        link: "/doc2/am_3.pdf"
    },
    {
        label: "ระเบียบสำนักงานศาลยุติธรรม ว่าด้วยการเข้าพักอาศัยในอาคารที่พักข้าราชการศาลยุติธรรมในเขตกรุงเทพมหานคร (ฉบับที่ 3) พ.ศ.2562",
        short: "ระเบียบการเข้าพักอาศัย (ฉบับที่ 3) พ.ศ.2562",
        link: "/doc2/am_4.pdf"
    },
    {
        label: "บัญชีอัตราค่าบำรุงสวัสดิการอาคารที่พักต่อหน่วย",
        short: "อัตราค่าบำรุง",
        link: "/doc2/am_5.pdf"
    }
]

const ListDocument = () => {
    return (
        <Accordion allowToggle w="100%" >
            {
                listDocument && listDocument.map((doc, index) => <Document label={breakptValue({ base: doc.short, md: doc.label })} index={index} link={doc.link} key={index} />)
            }
        </Accordion>
    )
}

export default ListDocument